import React from 'react'
import { cn } from 'cn'

const LinkBaseIcon = ({
  className,
  children
}: {
  children: React.JSX.Element | React.JSX.Element[]
  className?: string
}) => {
  return (
    <div
      className={cn(
        'sm:w-10 sm:h-10 w-8 h-8 shadow-xs rounded-xl transition-all duration-200 rounded-xl bg-gray-100/20 cursor-pointer hover:bg-gray-100/30 flex justify-center items-center',
        className
      )}
    >
      <div className="flex justify-center items-center">{children}</div>
    </div>
  )
}

export default LinkBaseIcon
